import { getService } from '../shell';
import { getLeadUrl, redirectToLead } from './redirectToLead';

/**
 * This is a simplified function for react. It is moved to separate component
 * because of imports from react modules
 */
export const redirectToLeadReact = (leadId: string | number): void => {
  redirectToLead({
    leadId,
    $state: getService('$state'),
    $location: getService('$location'),
  });
};

/**
 * This is a simplified function for react. It is moved to separate component
 * because of imports from react modules
 */
export const getLeadUrlReact = (leadId: string | number): string =>
  getLeadUrl({
    leadId,
    $state: getService('$state'),
    $location: getService('$location'),
  });
